import { render, staticRenderFns } from "./UserBankView.vue?vue&type=template&id=51bc85a0&scoped=true&"
import script from "./UserBankView.vue?vue&type=script&lang=js&"
export * from "./UserBankView.vue?vue&type=script&lang=js&"
import style0 from "./UserBankView.vue?vue&type=style&index=0&id=51bc85a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc85a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
